var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { StatisticsClient, IssuesClient, CompaniesClient, ActivityAuditClient, ActivityAuditSettingsModel, BatteryLifePredictionSettingsModel, IssueSettingsModel, CompanyServicesSettingsModel, AlarmsSettingsModel } from "@/app/api/battery-portal-api";
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const statisticsClient = new StatisticsClient(window.apiUrl);
const issuesClient = new IssuesClient(window.apiUrl);
const companiesClient = new CompaniesClient(window.apiUrl);
const activityAuditClient = new ActivityAuditClient(window.apiUrl);
let CompanySettingsVue = class CompanySettingsVue extends Vue {
    constructor() {
        super(...arguments);
        this.batteryLifePredictionSettingsModel = new BatteryLifePredictionSettingsModel();
        this.issueSettingsModel = new IssueSettingsModel();
        this.companyServicesSettingsModel = new CompanyServicesSettingsModel();
        this.alarmsSettingsModel = new AlarmsSettingsModel();
        this.activityAuditSettingsModel = new ActivityAuditSettingsModel();
        // Null means "use the default", which is why this is held separately from the model rather
        // than defaulting the input to the inherited number - filling the box in would make every
        // company look as though it had chosen a value.
        this.auditRetentionDays = null;
        this.auditRetentionImpact = null;
    }
    mounted() {
        this.getSettings();
    }
    getSettings() {
        this.loadBatteryLifePredictionSettings();
        this.loadIssuesSettings();
        this.loadCompanyServicesSettings();
        this.loadAlarmsSettings();
        this.loadActivityAuditSettings();
    }
    loadActivityAuditSettings() {
        activityAuditClient.getSettings(this.companyId)
            .then((response) => {
            var _a;
            if (response) {
                this.activityAuditSettingsModel = response;
                this.auditRetentionDays = (_a = response.daysToRetain) !== null && _a !== void 0 ? _a : null;
                this.auditRetentionImpact = null;
            }
        })
            .catch(() => {
            // Retention is one panel on a page of several. Failing to load it should not stop
            // the rest of the settings being editable.
        });
    }
    get auditRetentionPlaceholder() {
        var _a;
        const inherited = (_a = this.activityAuditSettingsModel) === null || _a === void 0 ? void 0 : _a.inheritedDaysToRetain;
        return inherited ? `Default (${inherited} days)` : "Use the default";
    }
    /// Asks the server what a proposed value would destroy. Only a reduction can destroy
    /// anything, so an increase is not worth a round trip.
    onAuditRetentionChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const proposed = this.auditRetentionDays;
            if (proposed == null || !Number.isInteger(proposed)) {
                this.auditRetentionImpact = null;
                return;
            }
            if (proposed >= ((_b = (_a = this.activityAuditSettingsModel) === null || _a === void 0 ? void 0 : _a.effectiveDaysToRetain) !== null && _b !== void 0 ? _b : 0)) {
                this.auditRetentionImpact = null;
                return;
            }
            try {
                this.auditRetentionImpact =
                    yield activityAuditClient.retentionImpact(this.companyId, proposed);
            }
            catch (_c) {
                this.auditRetentionImpact = null;
            }
        });
    }
    /// Called by the parent page when the company is saved.
    saveActivityAuditSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const model = new ActivityAuditSettingsModel({
                companyId: this.companyId,
                daysToRetain: (_a = this.auditRetentionDays) !== null && _a !== void 0 ? _a : null
            });
            yield activityAuditClient.upsertSettings(model);
        });
    }
    loadBatteryLifePredictionSettings() {
        statisticsClient.getBatteryLifePredictionSettings(this.companyId)
            .then((response) => {
            if (response && response.length == 1) {
                this.batteryLifePredictionSettingsModel = response[0];
                this.setValues({
                    ohmicRiseLimitForBlockReplacement: this.batteryLifePredictionSettingsModel.ohmicRiseLimitForBlockReplacement,
                    percOfBlocksAboveOhmicRiseLimitForStringReplacement: this.batteryLifePredictionSettingsModel.percOfBlocksAboveOhmicRiseLimitForStringReplacement,
                    minOhmicRiseToUsePrediction: this.batteryLifePredictionSettingsModel.minOhmicRiseToUsePrediction,
                });
            }
        });
    }
    loadIssuesSettings() {
        issuesClient.getSettings(this.companyId)
            .then((response) => {
            if (response) {
                this.issueSettingsModel = response;
                this.setValues({
                    ohmicCriticalAlarmDescription: this.issueSettingsModel.ohmicCriticalAlarmDescription,
                    ohmicCriticalAlarmTask: this.issueSettingsModel.ohmicCriticalAlarmTask,
                    ambTempCriticalAlarmDescription: this.issueSettingsModel.ambTempCriticalAlarmDescription,
                    ambTempCriticalAlarmTask: this.issueSettingsModel.ambTempCriticalAlarmTask,
                });
            }
        });
    }
    loadCompanyServicesSettings() {
        companiesClient.getServicesSettings(this.companyId)
            .then((response) => {
            if (response)
                this.companyServicesSettingsModel = response;
        });
    }
    loadAlarmsSettings() {
        companiesClient.getAlarmsSettings(this.companyId)
            .then((response) => {
            if (response)
                this.alarmsSettingsModel = response;
        });
    }
    validateSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            const { valid, errors } = yield this.validate();
            return valid;
        });
    }
    getBatteryLifePredictionSettings() {
        return this.batteryLifePredictionSettingsModel;
    }
    getIssueSettings() {
        return this.issueSettingsModel;
    }
    getCompanyServicesSettings() {
        return this.companyServicesSettingsModel;
    }
    getAlarmsSettings() {
        return this.alarmsSettingsModel;
    }
    get isPowerShield() {
        return this.loginState.isPowerShield;
    }
    ;
    get isAdministrator() {
        return this.loginState.isPowerShieldAdministrator;
    }
    ;
    get isClientAdministrator() {
        return this.loginState.isClientAdministrator;
    }
    ;
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], CompanySettingsVue.prototype, "loginState", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], CompanySettingsVue.prototype, "companyId", void 0);
__decorate([
    Watch("companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanySettingsVue.prototype, "getSettings", null);
__decorate([
    Watch("auditRetentionDays"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], CompanySettingsVue.prototype, "onAuditRetentionChanged", null);
CompanySettingsVue = __decorate([
    Component({
        name: "CompanySettingsVue",
        setup() {
            const { errors, validate, handleSubmit, defineInputBinds, setValues } = useForm({
                validationSchema: yup.object({
                    ohmicRiseLimitForBlockReplacement: yup.number().integer().min(1).max(100),
                    percOfBlocksAboveOhmicRiseLimitForStringReplacement: yup.number().integer().min(1).max(100),
                    minOhmicRiseToUsePrediction: yup.number().integer().min(1).max(100),
                    ohmicCriticalAlarmDescription: yup.string().max(250, 'Max 250 characters').nullable().notRequired(),
                    ohmicCriticalAlarmTask: yup.string().max(250, 'Max 250 characters').nullable().notRequired(),
                    ambTempCriticalAlarmDescription: yup.string().max(250, 'Max 250 characters').nullable().notRequired(),
                    ambTempCriticalAlarmTask: yup.string().max(250, 'Max 250 characters').nullable().notRequired(),
                }),
            });
            const ohmicRiseLimitForBlockReplacementVal = defineInputBinds('ohmicRiseLimitForBlockReplacement');
            const percOfBlocksAboveOhmicRiseLimitForStringReplacementVal = defineInputBinds('percOfBlocksAboveOhmicRiseLimitForStringReplacement');
            const minOhmicRiseToUsePredictionVal = defineInputBinds('minOhmicRiseToUsePrediction');
            const ohmicCriticalAlarmDescriptionVal = defineInputBinds('ohmicCriticalAlarmDescription');
            const ohmicCriticalAlarmTaskVal = defineInputBinds('ohmicCriticalAlarmTask');
            const ambTempCriticalAlarmDescriptionVal = defineInputBinds('ambTempCriticalAlarmDescription');
            const ambTempCriticalAlarmTaskVal = defineInputBinds('ambTempCriticalAlarmTask');
            return {
                errors,
                validate,
                handleSubmit,
                setValues,
                ohmicRiseLimitForBlockReplacementVal,
                percOfBlocksAboveOhmicRiseLimitForStringReplacementVal,
                minOhmicRiseToUsePredictionVal,
                ohmicCriticalAlarmDescriptionVal,
                ohmicCriticalAlarmTaskVal,
                ambTempCriticalAlarmDescriptionVal,
                ambTempCriticalAlarmTaskVal,
            };
        },
        expose: ["validateSettings", "getBatteryLifePredictionSettings", "getIssueSettings", "getCompanyServicesSettings", "getAlarmsSettings", "getActivityAuditSettings", "saveActivityAuditSettings"]
    })
], CompanySettingsVue);
export default CompanySettingsVue;
